import { render, staticRenderFns } from "./FollowerGoalWidgetPreview.vue?vue&type=template&id=74ac5c8c"
import script from "./FollowerGoalWidgetPreview.vue?vue&type=script&lang=js"
export * from "./FollowerGoalWidgetPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports